export default class ServiceTypeRequestPtDetailDataModel  {
    serviceTypeRequestPtDetailId:number;
    serviceTypeRequestPtId: number;
    specificBodyPartId: number;
    specificBodyPartName: string;
    injuryTypeId: number;
    injuryTypeName: string;
    bodySideId: number;
    bodySideName: string;
}